module.exports = __webpack_public_path__ + "assets/shopware.4af1a36b.svg";